import {
  deleteManufacturerAccount,
  getAllManufacturerAccounts,
  toggleManufacturerAccountStatus,
} from "app/services/manufacturers/manufacturers";
import { TOAST_SEVERITY } from "static/constants";
import { showToast } from "utils/toast";
import { useSelector } from "react-redux";
import { fetchManufacturers } from "app/services/dashboard/manufacturerService";
import { setManufacturers } from "app/store/manufacturers/slice/manufacturers.slice";

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const useManufacturerAccount = () => {
  const dispatch = useDispatch();

  const [pageSize, setPageSize] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [manufacturersAccounts, setManufacturerAccounts] = useState([]);
  const [selectedManufacturerAccount, setManufacturerAccount] = useState();
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showManufacturerAccountAddModal, setShowManufacturerAccountAddModal] =
    useState(false);
  const [
    showManufacturerAccountDeleteModal,
    setShowManufacturerAccountDeleteModal,
  ] = useState(false);

  const { manufacturers: manufacturerList } = useSelector(
    (state) => state.manufacturers
  );

  useEffect(() => {
    fetchManufacturerAccounts();
    fetchManufacturerList();
  }, []);

  const fetchManufacturerList = async () => {
    try {
      if (manufacturerList.length > 0) {
        return;
      }
      const manufacturers = await fetchManufacturers();
      dispatch(setManufacturers(manufacturers));
    } catch (error) {
      showToast({ message: error.message, type: TOAST_SEVERITY.ERROR });
    }
  };

  const handleDeactivateManufacturer = async (id, isActive, schedule) => {
    try {
      setIsFetching(true);
      if (!isActive) schedule = false;

      const payload = { isActive, schedule };
      const response = await toggleManufacturerAccountStatus(id, payload);
      if (response) {
        showToast({ message: response?.message });
      }
      fetchManufacturerAccounts();
    } catch (error) {
      showToast({ message: error?.message, type: TOAST_SEVERITY.ERROR });
    }
  };

  const handleDeactivateScheduling = async (id, schedule, isActive) => {
    try {
      setIsFetching(true);
      if (schedule) isActive = true;

      const payload = { schedule, isActive };
      const response = await toggleManufacturerAccountStatus(id, payload);
      if (response) {
        showToast({ message: response?.message });
      }
      fetchManufacturerAccounts();
    } catch (error) {
      showToast({ message: error?.message, type: TOAST_SEVERITY.ERROR });
    }
  };

  const deleteSelectedManufacturer = async (id) => {
    try {
      setIsDeleting(true);
      setShowManufacturerAccountDeleteModal(false);
      const response = await deleteManufacturerAccount(id);
      if (response) {
        showToast({ message: response.message });
        setIsDeleting(false);
        fetchManufacturerAccounts();
        setManufacturerAccount(null);
      }
    } catch (error) {
      showToast({ message: error.message, type: TOAST_SEVERITY.ERROR });
    }
  };

  const fetchManufacturerAccounts = async () => {
    try {
      setIsFetching(true);
      const manufacturer = await getAllManufacturerAccounts();
      setManufacturerAccounts(manufacturer);
    } catch (error) {
      showToast({ message: error.message, type: TOAST_SEVERITY.ERROR });
    } finally {
      setIsFetching(false);
    }
  };

  const getDeleteManufacturerAccountBodyText = () => {
    const { username } = selectedManufacturerAccount;
    const confirmDeleteText = `Are you sure you want to delete this user: ${username}?`;
    return confirmDeleteText;
  };

  return {
    pageSize,
    isFetching,
    isDeleting,
    manufacturersAccounts,
    showChangePasswordModal,
    selectedManufacturerAccount,
    showManufacturerAccountAddModal,
    showManufacturerAccountDeleteModal,

    setPageSize,
    setIsFetching,
    setIsDeleting,
    setManufacturerAccount,
    setManufacturerAccounts,
    fetchManufacturerAccounts,
    setShowChangePasswordModal,
    deleteSelectedManufacturer,
    handleDeactivateScheduling,
    handleDeactivateManufacturer,
    setShowManufacturerAccountAddModal,
    getDeleteManufacturerAccountBodyText,
    setShowManufacturerAccountDeleteModal,
  };
};

export default useManufacturerAccount;
